import { render, staticRenderFns } from "./Footer-links.vue?vue&type=template&id=6caa3551&"
import script from "./Footer-links.vue?vue&type=script&lang=js&"
export * from "./Footer-links.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports